module.exports = __webpack_public_path__ + "static/media/workingmemory-words-9.fa4cae86.mp3";